<template>
  <app-modal
    ref="modal"
    v-bind="$attrs"
    class="modal-container"
    content-class="modal-full"
    title="確認"
  >
    <template v-slot:body="{ cancel }">
      <validation-observer v-slot="{ handleSubmit }" as="div">
        <v-form novalidate @submit.stop.prevent="handleSubmit(submit)">
          <v-card-text class="pa-0">
            <div class="modal-body">
              <v-container fluid>
                <div class="font-weight-bold mb-3">
                  こちらの内容でSASEゲートウェイPalo
                  Alto向けVN回線を解約します。よろしいですか？
                </div>

                <div class="my-3">
                  <!-- 基本設定 -->
                  <v-row>
                    <v-col>
                      <h3>基本設定</h3>
                    </v-col>
                  </v-row>
                  <v-row class="px-4">
                    <!--タイプ-->
                    <v-col cols="4">
                      <app-label-group
                        label="タイプ"
                        :value="
                          $filter.enumTo(
                            saseGatewayServiceType,
                            'saseGatewayServiceType'
                          )
                        "
                      />
                    </v-col>
                    <!--サービスキー(Act)-->
                    <v-col cols="4">
                      <app-label-group
                        label="サービスキー(Act)"
                        :value="detailData.saseGatewayVnConnectAct.serviceKey"
                      />
                    </v-col>
                    <!--サービスキー(Sby)-->
                    <v-col cols="4">
                      <app-label-group
                        label="サービスキー(Sby)"
                        :value="detailData.saseGatewayVnConnectSby.serviceKey"
                      />
                    </v-col>
                    <!--品目-->
                    <v-col cols="4">
                      <app-label-group
                        label="品目"
                        :value="
                          detailData.saseGatewayVnConnectCommon.bandwidthType +
                          '(' +
                          $filter.bandwidthTo(
                            detailData.saseGatewayVnConnectCommon.bandwidth
                          ) +
                          ')'
                        "
                      />
                    </v-col>
                    <!--ロケーション-->
                    <v-col cols="4">
                      <app-label-group
                        label="ロケーション"
                        :value="
                          $filter.enumTo(
                            detailData.saseGatewayVnConnectCommon.location,
                            'location'
                          )
                        "
                      />
                    </v-col>
                    <!--備考-->
                    <v-col cols="4">
                      <app-label-group
                        label="備考"
                        :value="
                          $filter.emptyTo(
                            detailData.saseGatewayVnConnectCommon.description,
                            '-'
                          )
                        "
                      />
                    </v-col>
                  </v-row>

                  <!-- 接続先VPN/VN -->
                  <v-row>
                    <v-col>
                      <h3>接続先VPN/VN</h3>
                    </v-col>
                  </v-row>
                  <v-row class="px-4">
                    <!--接続先VPN/VNコード-->
                    <v-col cols="4">
                      <app-label-group
                        label="接続先VPN/VNコード"
                        :value="detailData.saseGatewayVnConnectCommon.vpnVnCode"
                      />
                    </v-col>
                    <!--仮想ネットワーク(VN)名-->
                    <v-col cols="4">
                      <app-label-group
                        label="仮想ネットワーク(VN)名"
                        :value="
                          detailData.saseGatewayVnConnectCommon.vpnVnCode.startsWith(
                            'B'
                          )
                            ? '-'
                            : detailData.saseGatewayVnConnectCommon.vnName
                        "
                      />
                    </v-col>
                    <v-col cols="4">
                      <app-label-group
                        label="L2/L3"
                        :value="detailData.saseGatewayVnConnectCommon.vnType"
                      />
                    </v-col>
                    <v-col cols="4">
                      <app-label-group
                        label="ルーティング種別"
                        :value="
                          detailData.saseGatewayVnConnectCommon.routingType
                        "
                      />
                    </v-col>
                    <v-col cols="4">
                      <app-label-group
                        label="AS番号"
                        :value="detailData.saseGatewayVnConnectCommon.asNumber"
                      />
                    </v-col>
                    <v-col cols="4">
                      <app-label-group
                        label="Maximum Prefix"
                        :value="
                          detailData.saseGatewayVnConnectCommon.maximumPrefix
                        "
                      />
                    </v-col>
                  </v-row>

                  <!-- VNコネクト情報(Act) -->
                  <v-row class="mt-2">
                    <v-col>
                      <h3>VNコネクト情報(Act)</h3>
                    </v-col>
                  </v-row>
                  <v-row class="px-4">
                    <v-col cols="4">
                      <!--VNコネクト番号-->
                      <app-label-group
                        label="VNコネクト番号"
                        :value="detailData.saseGatewayVnConnectAct.wnumber"
                      />
                    </v-col>
                    <!--VNコネクト名-->
                    <v-col cols="4">
                      <app-label-group
                        label="VNコネクト名"
                        :value="
                          detailData.saseGatewayVnConnectAct.vnConnectName
                        "
                      />
                    </v-col>
                    <v-col cols="4">
                      <app-label-group
                        label="VNコネクト状態"
                        :value="
                          $filter.enumTo(
                            detailData.saseGatewayVnConnectAct
                              .isVnConnectStatus,
                            'enable'
                          )
                        "
                      />
                    </v-col>
                    <v-col cols="4">
                      <app-label-group
                        label="IF状態"
                        :value="
                          $filter.enumTo(
                            detailData.saseGatewayVnConnectAct.ifStatus,
                            'cloudVn_ifStatus'
                          )
                        "
                      />
                    </v-col>
                  </v-row>

                  <!-- VNコネクト情報(Sby) -->
                  <v-row class="mt-2">
                    <v-col>
                      <h3>VNコネクト情報(Sby)</h3>
                    </v-col>
                  </v-row>
                  <v-row class="px-4">
                    <v-col cols="4">
                      <!--VNコネクト番号-->
                      <app-label-group
                        label="VNコネクト番号"
                        :value="detailData.saseGatewayVnConnectSby.wnumber"
                      />
                    </v-col>
                    <!--VNコネクト名-->
                    <v-col cols="4">
                      <app-label-group
                        label="VNコネクト名"
                        :value="
                          detailData.saseGatewayVnConnectSby.vnConnectName
                        "
                      />
                    </v-col>
                    <v-col cols="4">
                      <app-label-group
                        label="VNコネクト状態"
                        :value="
                          $filter.enumTo(
                            detailData.saseGatewayVnConnectSby
                              .isVnConnectStatus,
                            'enable'
                          )
                        "
                      />
                    </v-col>
                    <v-col cols="4">
                      <app-label-group
                        label="IF状態"
                        :value="
                          $filter.enumTo(
                            detailData.saseGatewayVnConnectSby.ifStatus,
                            'cloudVn_ifStatus'
                          )
                        "
                      />
                    </v-col>
                  </v-row>

                  <!-- ルーティング情報(Act) -->
                  <v-row class="mt-2">
                    <v-col>
                      <h3>ルーティング情報(Act)</h3>
                    </v-col>
                  </v-row>
                  <v-row class="px-4">
                    <!--WANアドレス(Act)-->
                    <v-col cols="4">
                      <app-label-group
                        label="WANアドレス"
                        :value="detailData.saseGatewayVnConnectAct.wanAddress"
                      />
                    </v-col>
                    <!--ピアIPアドレス(Act)-->
                    <v-col cols="4">
                      <app-label-group
                        label="ピアIPアドレス"
                        :value="
                          detailData.saseGatewayVnConnectAct.peerIpAddress
                        "
                      />
                    </v-col>
                    <!--Local Preference(Act)-->
                    <v-col cols="4">
                      <app-label-group
                        label="Local Preference"
                        :value="
                          $filter.enumTo(
                            detailData.saseGatewayVnConnectAct.localPreference,
                            'localPreference'
                          )
                        "
                      />
                    </v-col>
                    <!--MED(Act)-->
                    <v-col cols="4">
                      <app-label-group
                        label="MED"
                        :value="
                          $filter.enumTo(
                            detailData.saseGatewayVnConnectAct.med,
                            'med'
                          )
                        "
                      />
                    </v-col>
                  </v-row>

                  <!-- ルーティング情報(Sby) -->
                  <v-row class="mt-2">
                    <v-col>
                      <h3>ルーティング情報(Sby)</h3>
                    </v-col>
                  </v-row>
                  <v-row class="px-4">
                    <!--WANアドレス(Sby)-->
                    <v-col cols="4">
                      <app-label-group
                        label="WANアドレス"
                        :value="detailData.saseGatewayVnConnectSby.wanAddress"
                      />
                    </v-col>
                    <!--ピアIPアドレス(Sby)-->
                    <v-col cols="4">
                      <app-label-group
                        label="ピアIPアドレス"
                        :value="
                          detailData.saseGatewayVnConnectSby.peerIpAddress
                        "
                      />
                    </v-col>
                    <!--Local Preference(Sby)-->
                    <v-col cols="4">
                      <app-label-group
                        label="Local Preference"
                        :value="
                          $filter.enumTo(
                            detailData.saseGatewayVnConnectSby.localPreference,
                            'localPreference'
                          )
                        "
                      />
                    </v-col>
                    <!--MED(Sby)-->
                    <v-col cols="4">
                      <app-label-group
                        label="MED"
                        :value="
                          $filter.enumTo(
                            detailData.saseGatewayVnConnectSby.med,
                            'med'
                          )
                        "
                      />
                    </v-col>
                  </v-row>

                  <!-- カスタム経路集約情報 -->
                  <v-row class="mt-2">
                    <v-col>
                      <h3>カスタム経路集約情報</h3>
                    </v-col>
                  </v-row>
                  <v-row class="px-4">
                    <!--経路集約-->
                    <v-col cols="4">
                      <app-label-group
                        label="経路集約"
                        :value="
                          detailData.saseGatewayVnConnectCommon.routeAggregation
                        "
                      />
                    </v-col>
                  </v-row>
                  <!--経路集約アドレス-->
                  <v-row
                    class="px-4"
                    v-if="
                      detailData.saseGatewayVnConnectCommon.routeAggregation ===
                      'CUSTOM'
                    "
                  >
                    <v-col>
                      <app-label-group label="経路集約アドレス">
                        <template #value>
                          <div class="ml-3">
                            <template
                              v-for="(
                                ip, index
                              ) in sortedRouteAggregationAddressList"
                              :key="index"
                            >
                              <div>
                                {{ ip }}
                              </div>
                            </template>
                          </div>
                        </template>
                      </app-label-group>
                    </v-col>
                  </v-row>

                  <!-- 保守連絡先情報 -->
                  <v-row class="mt-2">
                    <v-col>
                      <h3>保守連絡先情報</h3>
                    </v-col>
                  </v-row>
                  <v-row class="px-4">
                    <v-col cols="4">
                      <app-label-group
                        label="会社名"
                        :value="detailData.maintenance.company"
                      />
                    </v-col>
                    <v-col cols="4">
                      <app-label-group
                        label="部署名"
                        :value="detailData.maintenance.department"
                      />
                    </v-col>
                    <v-col cols="4">
                      <app-label-group
                        label="担当者名"
                        :value="detailData.maintenance.name"
                      />
                    </v-col>
                    <v-col cols="4">
                      <app-label-group
                        label="電話番号"
                        :value="detailData.maintenance.phone"
                      />
                    </v-col>
                    <v-col cols="4">
                      <app-label-group
                        label="メールアドレス"
                        :value="detailData.maintenance.email"
                      />
                    </v-col>
                  </v-row>
                </div>

                <div class="d-flex justify-center">
                  <v-checkbox
                    hide-details
                    v-model="accepted"
                    label="契約(料金変更)に関わる操作を実施します。"
                  ></v-checkbox>
                </div>
              </v-container>
            </div>
          </v-card-text>
          <v-divider></v-divider>
          <v-card-actions>
            <v-list-item class="w-100 pa-1">
              <template v-slot:append>
                <v-btn
                  type="submit"
                  variant="flat"
                  color="primary"
                  :disabled="!accepted"
                  >はい
                </v-btn>
                <v-btn variant="outlined" color="primary" @click="cancel"
                  >いいえ
                </v-btn>
              </template>
            </v-list-item>
          </v-card-actions>
        </v-form>
      </validation-observer>
    </template>
  </app-modal>
</template>

<script lang="ts">
import { defineComponent } from "vue";
import type { PropType } from "vue";
import type { SaseGatewayPaloAltoDetailEntity } from "@/apis/SaseGatewayApi";
import { VueFinalModal } from "vue-final-modal";
import AppLabelGroup from "@/components/AppLabelGroup.vue";

export default defineComponent({
  name: "SaseGatewayPaloAltoDeleteConfirm",
  components: { AppLabelGroup },
  props: {
    detailData: {
      type: Object as PropType<SaseGatewayPaloAltoDetailEntity>,
      required: true,
    },
    saseGatewayServiceType: {
      type: String as PropType<string>,
      required: true,
    },
  },
  data() {
    return {
      accepted: false,
    };
  },
  computed: {
    /**
     * 経路集約アドレスリストを数値順(IPアドレス順)で昇順ソート
     * @returns ソート済みの経路集約アドレスリスト
     */
    sortedRouteAggregationAddressList(): string[] {
      const list =
        this.detailData.saseGatewayVnConnectCommon
          ?.routeAggregationAddressList ?? [];
      return list.sortIpAddress();
    },
  },
  methods: {
    submit() {
      (this.$refs.modal as typeof VueFinalModal & { ok: () => void }).ok();
    },
  },
});
</script>
